class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');

    if (!facetWrapper) {
      return;
    }

    facetWrapper.addEventListener('keyup', onKeyUpEscape);

    const facets = facetWrapper.querySelectorAll('details');

    if (facets.length > 0) {
      facets[0].setAttribute('open', '');
    }

    /* ---- אקורדיון: פתיחת סינון סוגרת את כל הסינונים האחרים ----
       גרסה פשוטה ואמינה: לא מבטלים את ההתנהגות הטבעית של <details>
       (אין preventDefault), רק מגיבים לאירוע ה-toggle הטבעי וסוגרים
       את כל השאר. נכון שהאנימציה פחות חלקה מגרסה קודמת שניסינו (עם
       שליטה מלאה ב-max-height), אבל אותה גרסה נשענה על הנחות לגבי
       איך הדפדפן "מסתיר" תוכן ב-<details> סגור שהתבררו כשגויות
       בדפדפנים מודרניים (יש להם מנגנון הסתרה פנימי, לא display:none
       פשוט על התוכן) - מה שגרם לנעילה מלאה. גרסה זו לא נוגעת בכלל
       במנגנון ההסתרה הפנימי של הדפדפן - רק מוסיפה עליו את הכלל
       "פתיחה סוגרת אחרים", ולכן אמינה בהרבה.
       מאזין על facetWrapper עצמו (לא על כל <details> בנפרד) עם capture: true,
       כי אירוע 'toggle' לא מבעבע (bubbles: false) - אבל בשלב ה-capture הוא
       עדיין נתפס בדרך למטה אל האלמנט. חשוב גם כדי שימשיך לעבוד אחרי
       שרינדור AJAX מחליף innerHTML של סינונים אחרים (המאזין על אב קבוע). */
    facetWrapper.addEventListener(
      'toggle',
      (event) => {
        const target = event.target;
        if (target.tagName !== 'DETAILS' || !target.open) return;

        facetWrapper.querySelectorAll('details[open]').forEach((otherDetails) => {
          if (otherDetails !== target) {
            otherDetails.removeAttribute('open');
          }
        });
      },
      true
    );
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

        let containerProducts = document.querySelector('#product-grid');
        new theme.QuickAdd(containerProducts);
        var api = new Yotpo.API(yotpo);
        api.refreshWidgets();

        // if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);

    let containerProducts = document.querySelector('#product-grid');
    new theme.QuickAdd(containerProducts);
    var api = new Yotpo.API(yotpo);
    api.refreshWidgets();

    // if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    // document
    //   .getElementById('ProductGridContainer')
    //   .querySelectorAll('.scroll-trigger')
    //   .forEach((element) => {
    //     element.classList.add('scroll-trigger--cancel');
    //   });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
    const endlessCollection = new Ajaxinate({
      container: '#product-grid',
      pagination: '.infinite_next',
    });
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newElementSelector = document
          .getElementById(closestJSFilterID)
          .classList.contains('mobile-facets__details')
          ? `#${closestJSFilterID} .mobile-facets__close-button`
          : `#${closestJSFilterID} .facets__summary`;
        const newElementToActivate = document.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onChooseFilter(event) {
    let element = document.querySelector('summary.mobile-facets__open-wrapper');
    const scrollElement = document.querySelector('.collection_main_container')
    if (element && scrollElement) {
      element.click();
      let scrollPosition = scrollElement.getBoundingClientRect().top;
      window.scroll({
        top: scrollPosition,
        left: 0,
        behavior: "smooth",
      });
    }
  }

  onSubmitForm(searchParams, event) {

    FacetFiltersForm.renderPage(searchParams, event);
    if (window.innerWidth < 750) {
      this.onChooseFilter(event);
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    this.onChooseFilter(event);
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

/* ====================================================================
   דימוי sticky אמיתי לשורת "כמות מוצרים + סינון" במובייל
   ====================================================================
   position: sticky הרגיל לא עבד כאן כי ההורה הישיר של האלמנט
   (.facets-container) קטן מדי בגובה - אין ל-sticky "מקום לנוע" בתוכו
   לפני שההורה כבר "נגמר" ונגלל הלאה, כך שההדבקה לא נראית לעין בכלל.
   הפתרון: מודדים בעצמנו היכן האלמנט נמצא באופן טבעי בטעינת הדף, ורק
   כשהגלילה עוברת את הנקודה הזו, מחליפים אותו ל-position: fixed (שלא
   תלוי בגובה ההורה) - ומחזירים אותו למצב הטבעי כשגוללים חזרה למעלה.
   ==================================================================== */
(function () {
  function initStickyMobileFacetsBar() {
    var bar = document.querySelector('.facets-container .mobile-facets__wrapper');
    if (!bar || bar.dataset.rsStickyInit === 'true') return;
    bar.dataset.rsStickyInit = 'true';

    var STICKY_TOP = 88; // חשוב: אותו ערך שמוגדר ב-CSS (.rs-mobile-facets-stuck)

    // ספייסר ששומר על המקום שהאלמנט תפס, כדי שהתוכן מתחתיו לא "יקפוץ"
    // למעלה כשהאלמנט הופך ל-fixed ויוצא מזרימת הדף
    var spacer = document.createElement('div');
    spacer.className = 'rs-mobile-facets-spacer';
    bar.parentNode.insertBefore(spacer, bar.nextSibling);

    var naturalOffsetTop = null;

    function measureNaturalOffset() {
      // מודדים רק כשהאלמנט עדיין במצב הטבעי שלו (לא fixed) - אחרת
      // המדידה תהיה שגויה (יחסית ל-viewport, לא לזרימת הדף)
      if (!bar.classList.contains('rs-mobile-facets-stuck')) {
        var rect = bar.getBoundingClientRect();
        naturalOffsetTop = rect.top + window.scrollY;
        spacer.style.height = bar.offsetHeight + 'px';
      }
    }

    function onScrollOrResize() {
      if (window.innerWidth >= 750) return; // רלוונטי למובייל בלבד
      if (naturalOffsetTop === null) return;

      var shouldStick = window.scrollY >= naturalOffsetTop - STICKY_TOP;

      if (shouldStick && !bar.classList.contains('rs-mobile-facets-stuck')) {
        bar.classList.add('rs-mobile-facets-stuck');
        spacer.classList.add('is-active');
      } else if (!shouldStick && bar.classList.contains('rs-mobile-facets-stuck')) {
        bar.classList.remove('rs-mobile-facets-stuck');
        spacer.classList.remove('is-active');
        measureNaturalOffset(); // מודדים מחדש למקרה שהגובה הטבעי השתנה
      }
    }

    /* חשוב: לא מודדים מיד בטעינת ה-DOM - בשלב הזה תמונות (כמו קרוסלת
       המוצרים מעל השורה) עדיין לא בהכרח נטענו וקיבלו את הגודל האמיתי
       שלהן, כך שהמדידה הראשונית הייתה קטנה מהאמת וגרמה ל-sticky
       "לחשוב" שכבר עברו את נקודת הגלילה - ולהידבק כבר בטעינה, בטעות.
       מודדים אחרי אירוע 'load' (כשכל התמונות כבר נטענו), ועוד פעם אחת
       נוספת בתזמון קצר כרשת ביטחון עבור תמונות שנטענות באיחור (lazyload) */
    window.addEventListener('load', function () {
      measureNaturalOffset();
      onScrollOrResize();
    });
    window.setTimeout(function () {
      measureNaturalOffset();
      onScrollOrResize();
    }, 1500);

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', function () {
      if (!bar.classList.contains('rs-mobile-facets-stuck')) {
        spacer.style.height = bar.offsetHeight + 'px';
      }
    });

    onScrollOrResize();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyMobileFacetsBar);
  } else {
    initStickyMobileFacetsBar();
  }
})();

/* ====================================================================
   מיקום תפריט הסינון הנפתח (הדראוור) ממש מתחת להדר - בכל פעם שהוא נפתח
   ====================================================================
   בלי זה, התפריט נפתח לפי ערך top קבוע שמוגדר בקובץ CSS אחר בתמה,
   שלא בהכרח מתאים לגובה האמיתי של ההדר בכל מצב (למשל אם יש שורת
   הודעה שמשנה את הגובה, או שגובה ההדר עצמו משתנה בגלילה). כאן מודדים
   את הגובה האמיתי של ההדר ברגע הפתיחה עצמו, ומעדכנים לפיו - כך שהתפריט
   תמיד ייפתח צמוד להדר, לא משנה מה מצב הגלילה. */
(function () {
  function alignMobileFacetsDrawer() {
    var drawer = document.getElementById('FacetFiltersFormMobile');
    var header = document.getElementById('SiteHeader') || document.querySelector('header');
    if (!drawer || !header) return;
    var headerHeight = header.getBoundingClientRect().bottom;
    drawer.style.top = Math.max(headerHeight, 0) + 'px';
  }

  function initMobileFacetsDrawerAlignment() {
    var disclosure = document.querySelector('.mobile-facets__disclosure');
    if (!disclosure || disclosure.dataset.rsAlignInit === 'true') return;
    disclosure.dataset.rsAlignInit = 'true';

    disclosure.addEventListener('toggle', function () {
      if (disclosure.open) {
        alignMobileFacetsDrawer();
      }
    });

    window.addEventListener('resize', function () {
      if (disclosure.open) {
        alignMobileFacetsDrawer();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileFacetsDrawerAlignment);
  } else {
    initMobileFacetsDrawerAlignment();
  }
})();

/* ====================================================================
   סיידבר סינון קבוע במחשב (#main-collection-filters) - JS, לא CSS sticky
   ====================================================================
   position: sticky לא עבד (מסיבה שלא הצלחנו לאתר). זו בדיוק אותה שיטה
   שכבר עובדת בהצלחה לשורת הסינון במובייל (מעל): מודדים איפה האלמנט נמצא
   באופן טבעי, ובגלילה שעוברת את הנקודה הזו מחליפים ל-position: fixed -
   שלא תלוי ב-sticky, ב-overflow, או בכל דבר אחר שמצאנו/לא מצאנו. הרוחב
   קבוע (300px) בשני המצבים כדי שלא תהיה קפיצה/שינוי מראה. */
(function () {
  function initStickyDesktopFilters() {
    var sidebar = document.getElementById('main-collection-filters');
    if (!sidebar || sidebar.dataset.rsStickyDesktopInit === 'true') return;
    sidebar.dataset.rsStickyDesktopInit = 'true';

    var TOP_GAP = 52; // רווח בין תחתית ההדר לראש הסיידבר, כשהוא נדבק

    var spacer = document.createElement('div');
    spacer.className = 'rs-desktop-filters-spacer';
    sidebar.parentNode.insertBefore(spacer, sidebar.nextSibling);

    var naturalOffsetTop = null;
    var naturalLeft = null;

    function getHeaderHeight() {
      var val = getComputedStyle(document.documentElement).getPropertyValue('--rs-header-h');
      var num = parseFloat(val);
      return isNaN(num) ? 0 : num;
    }

    function measureNatural() {
      if (!sidebar.classList.contains('rs-desktop-filters-stuck')) {
        var rect = sidebar.getBoundingClientRect();
        naturalOffsetTop = rect.top + window.scrollY;
        naturalLeft = rect.left;
        spacer.style.height = sidebar.offsetHeight + 'px';
      }
    }

    function unstick() {
      sidebar.classList.remove('rs-desktop-filters-stuck');
      spacer.classList.remove('is-active');
      sidebar.style.removeProperty('top');
      sidebar.style.removeProperty('left');
      sidebar.style.removeProperty('width');
    }

    function onScrollOrResize() {
      if (window.innerWidth < 750) {
        if (sidebar.classList.contains('rs-desktop-filters-stuck')) unstick();
        return;
      }
      if (naturalOffsetTop === null) return;

      var headerH = getHeaderHeight();
      var stickAt = naturalOffsetTop - headerH - TOP_GAP;
      var shouldStick = window.scrollY >= stickAt;

      if (shouldStick) {
        sidebar.classList.add('rs-desktop-filters-stuck');
        spacer.classList.add('is-active');
        sidebar.style.setProperty('top', (headerH + TOP_GAP) + 'px', 'important');
        sidebar.style.setProperty('left', naturalLeft + 'px', 'important');
        sidebar.style.setProperty('width', '300px', 'important');
      } else if (sidebar.classList.contains('rs-desktop-filters-stuck')) {
        unstick();
        measureNatural();
      }
    }

    window.addEventListener('load', function () {
      measureNatural();
      onScrollOrResize();
    });
    window.setTimeout(function () {
      measureNatural();
      onScrollOrResize();
    }, 1500);

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', function () {
      if (!sidebar.classList.contains('rs-desktop-filters-stuck')) {
        measureNatural();
      } else {
        unstick();
        measureNatural();
        onScrollOrResize();
      }
    });

    measureNatural();
    onScrollOrResize();

    /* אכיפה מתמשכת - בודקת ומתקנת את הרוחב כל 300 מילישניות, בלי תלות
       בגלילה או בכל אירוע אחר. משהו ממשיך לשנות את הרוחב אחרי שקבענו
       אותו - זה יתפוס את זה ויתקן, כל הזמן, לא משנה מאיפה זה מגיע */
    setInterval(function () {
      if (sidebar.classList.contains('rs-desktop-filters-stuck')) {
        sidebar.style.setProperty('width', '300px', 'important');
      }
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyDesktopFilters);
  } else {
    initStickyDesktopFilters();
  }
})();
